ACC.asm = {

	_autoload: [
		"asmFormLogin",
	],     
    
    asmFormLogin: function () {
        var signInBtn = $("#asmLoginForm button[type='submit']");


		function checkEmpty() {
			if (!$("#asmLoginForm input[name='username'], #asmLoginForm input[name='password']").val() == ""){
				signInBtn.removeAttr('disabled');
			}
		}
		checkEmpty();

		$("#asmLoginForm input[name='username'], #asmLoginForm input[name='password']").blur(function () {
			checkEmpty();
		});
    }
}